const PADDING_OUTER = 1;
const PADDING_TOP = 22;
const PADDING_INNER = 1;

export { 
  PADDING_OUTER,
  PADDING_TOP,
  PADDING_INNER
};